import {createSlice} from '@reduxjs/toolkit';

export interface SettingsInterface {
    isLoading: boolean;
    org_uid: string;
    allow_background_removal: boolean;
    error: any;
}

const DefaultSettingsState: SettingsInterface = {
    isLoading: false,
    org_uid: '',
    allow_background_removal: true,
    error: null,
};

const SettingsSlice = createSlice({
    name: 'settings',
    initialState: DefaultSettingsState,
    reducers: {
        settingsDataRequest: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        settingsDataSuccess: (state, action) => {
            state.org_uid = action.payload.org_uid;
            state.allow_background_removal = action.payload.allow_background_removal;
            state.isLoading = false;
        },
        settingsDataFailure: (state) => {
            state.isLoading = false;
            state.error = 'error fetching org settings';
        },
    },
});

const {settingsDataRequest, settingsDataSuccess, settingsDataFailure} = SettingsSlice.actions;

export {settingsDataRequest, settingsDataSuccess, settingsDataFailure};

export default SettingsSlice.reducer;
